import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgAbs } from '../../fg-math.js';

const absDef = {
  type: FgBlockType.Abs,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", fgAbs(getDataValue(ctx, env, block, "a")));
  }
};

export { absDef };
//# sourceMappingURL=abs.js.map
